import { render, staticRenderFns } from "./SrFiltersTemplate.vue?vue&type=template&id=6d6f061b&scoped=true"
import script from "./SrFiltersTemplate.vue?vue&type=script&lang=js"
export * from "./SrFiltersTemplate.vue?vue&type=script&lang=js"
import style0 from "./SrFiltersTemplate.vue?vue&type=style&index=0&id=6d6f061b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6f061b",
  null
  
)

export default component.exports